import { render, staticRenderFns } from "./MemberContact.vue?vue&type=template&id=5cabd6c3&scoped=true&"
import script from "./MemberContact.vue?vue&type=script&lang=js&"
export * from "./MemberContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabd6c3",
  null
  
)

export default component.exports